import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 路由懒加载
const Login = () => import('../views/Login.vue')
const Layout = () => import('../layout/Layout.vue')
const Dashboard = () => import('../views/Dashboard.vue')
const CommunityList = () => import('../views/community/CommunityList.vue')
const StaffList = () => import('../views/community/StaffList.vue')
const MerchantStaffList = () => import('../views/merchant/StaffList.vue')
const MerchantList = () => import('../views/merchant/MerchantList.vue')
const MerchantDetail = () => import('../views/merchant/MerchantDetail.vue')
const ProductList = () => import('../views/product/ProductList.vue')
const bannerList = () => import('../views/banner/Banner.vue')
const OrderList = () => import('../views/order/OrderList.vue')
const VerifyLog = () => import('../views/order/VerifyLog.vue')
const UserList = () => import('../views/user/UserList.vue')
const VerificationList = () => import('../views/user/VerificationList.vue')
const WhitelistList = () => import('../views/whitelist/WhitelistList.vue')
const NotificationList = () => import('../views/notification/NotificationList.vue')

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { title: '登录' }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: { title: '工作台', icon: 'el-icon-data-line', affix: true }
      }
    ]
  },
  {
    path: '/community',
    component: Layout,
    redirect: '/community/list',
    meta: { title: '社区管理', icon: 'el-icon-office-building' },
    children: [
      {
        path: 'list',
        name: 'CommunityList',
        component: CommunityList,
        meta: { title: '社区列表' }
      },
      {
        path: 'staff',
        name: 'StaffList',
        component: StaffList,
        meta: { title: '工作人员管理' }
      }
    ]
  },
  {
    path: '/merchant',
    component: Layout,
    redirect: '/merchant/list',
    meta: { title: '商户管理', icon: 'el-icon-s-shop' },
    children: [
      {
        path: 'list',
        name: 'MerchantList',
        component: MerchantList,
        meta: { title: '商户审核列表' }
      },
      {
        path: 'merchantStaff',
        name: 'MerchantStaffList',
        component: MerchantStaffList,
        meta: { title: '商户人员管理' }
      }
    ]
  },
  {
    path: '/merchant/detail/:id',
    component: Layout,
    meta: { title: '商户详情', hidden: true },
    children: [
      {
        path: '',
        name: 'MerchantDetail',
        component: MerchantDetail,
        meta: { title: '商户详情', hidden: true }
      }
    ]
  },
  {
    path: '/product',
    component: Layout,
    redirect: '/product/list',
    meta: { title: '商品管理', icon: 'el-icon-s-goods' },
    children: [
      {
        path: 'list',
        name: 'ProductList',
        component: ProductList,
        meta: { title: '商品列表' }
      }
    ]
  },
  {
    path: '/banner',
    component: Layout,
    redirect: '/banner/list',
    meta: { title: '运营位管理', icon: 'el-icon-s-goods' },
    children: [
      {
        path: 'list',
        name: 'bannerList',
        component: bannerList,
        meta: { title: '运营位列表' }
      }
    ]
  },
  {
    path: '/order',
    component: Layout,
    redirect: '/order/list',
    meta: { title: '订单管理', icon: 'el-icon-s-order' },
    children: [
      {
        path: 'list',
        name: 'OrderList',
        component: OrderList,
        meta: { title: '订单列表' }
      },
      {
        path: 'verify-log',
        name: 'VerifyLog',
        component: VerifyLog,
        meta: { title: '核销记录' }
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    redirect: '/user/list',
    meta: { title: '用户管理', icon: 'el-icon-user-solid' },
    children: [
      {
        path: 'list',
        name: 'UserList',
        component: UserList,
        meta: { title: '用户列表' }
      },
      {
        path: 'verification',
        name: 'VerificationList',
        component: VerificationList,
        meta: { title: '实名认证审核' }
      }
    ]
  },
  {
    path: '/whitelist',
    component: Layout,
    redirect: '/whitelist/list',
    meta: { title: '白名单管理', icon: 'el-icon-s-check' },
    children: [
      {
        path: 'list',
        name: 'WhitelistList',
        component: WhitelistList,
        meta: { title: '困难人群白名单' }
      }
    ]
  },
  {
    path: '/notification',
    component: Layout,
    redirect: '/notification/list',
    meta: { title: '消息管理', icon: 'el-icon-message' },
    children: [
      {
        path: 'list',
        name: 'NotificationList',
        component: NotificationList,
        meta: { title: '消息推送' }
      }
    ]
  },
  {
    path: '*',
    redirect: '/dashboard'
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

// 全局路由守卫
router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title || ''} - 爱心食物银行管理后台`
  const token = localStorage.getItem('token')
  if (to.path === '/login') {
    if (token) {
      next('/dashboard')
    } else {
      next()
    }
  } else {
    if (!token) {
      next('/login')
    } else {
      next()
    }
  }
})

export default router
